<template>
    <div class="missing-page-wrapper">
        <div class="redirect-content">
            <div class="header-container">
                <div class="header">404</div>
                <div class="plug-boy desktop-only">
                    <plug-boy />
                </div>
            </div>
            <div class="sub-header">
                We just couldn't find that Spark...
            </div>
            <primevue-button text class="return-btn plain-btn" @click="returnHome">
                <font-awesome-icon :icon="['fas', 'arrow-left']" />
                Return to home
            </primevue-button>
            <div class="game-section">
                <p class="game-prompt">404 Hz not found - recalibrate the grid?</p>
                <game-selector />
            </div>
        </div>
        <div class="logo-container desktop-only">
            <img class="spark-lines" :src="sparkLines" alt="spark lines splash" />
            <img class="spark-logo" :src="sparkLogo" alt="spark logo" />
        </div>
    </div>
</template>

<script setup lang="ts">
import PrimevueButton from 'primevue/button';
import { useRouter } from 'vue-router';
import PlugBoy from '@/components/layout/PlugBoy.vue';
import GameSelector from '@/components/layout/GameSelector.vue';
import { useUIStore } from '@/stores/uiStore.ts';
import sparkLines from '@/assets/imgs/svgs/spark-lines.svg';
import sparkLogo from '@/assets/imgs/svgs/spark-logo.svg';

const uiStore = useUIStore();
const router = useRouter();

function returnHome (): void {
    router.push('/home');
}

function initialise (): void {
    uiStore.setPageLoader(false);
}

initialise();
</script>

<style lang="scss" scoped>
.missing-page-wrapper {
    height: 100%;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 0 5%;
    overflow: auto;

    @include responsive('md') {
        grid-template-columns: 1fr;
    }
}

.redirect-content {
    display: flex;
    flex-direction: column;
    width: fit-content;
    gap: var(--extraLargeSpacing);
    z-index: 1;
    place-self: center;

    .header-container {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .header {
            font-size: 10rem;
            margin-bottom: var(--largeSpacing);
            color: var(--accentColour);

            @include responsive('md') {
                margin: 0;
            }
        }

        .plug-boy {
            display: flex;
            align-items: center;
            width: 22rem;
            z-index: 1;
        }
    }

    .sub-header {
        font-size: 3rem;

        @include responsive('md') {
            text-align: center;
        }
    }

    .return-btn {
        height: 5rem;
        width: 100%;
    }

    .game-section {
        display: flex;
        flex-direction: row;
        gap: var(--defaultSpacing);
        align-items: center;

        .game-prompt {
            margin: 0;
            font-size: var(--mediumFontSize);
            color: var(--neutral600);
            font-style: italic;
        }
    }
}

.logo-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .spark-lines {
        position: absolute;
        width: 110%;
        z-index: 0;
        opacity: 0.4;
    }

    .spark-logo {
        position: absolute;
        z-index: 1;
        width: 30%;
        opacity: 0.9;
    }
}
</style>
